"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Merger = void 0;
const PreludeCard_1 = require("../prelude/PreludeCard");
const CardName_1 = require("../../CardName");
const CardRenderer_1 = require("../render/CardRenderer");
const SelectCard_1 = require("../../inputs/SelectCard");
const Dealer_1 = require("../../Dealer");
const DrawCards_1 = require("../../deferredActions/DrawCards");
const LogHelper_1 = require("../../LogHelper");
const DeferredAction_1 = require("../../deferredActions/DeferredAction");
const constants_1 = require("../../constants");
const SelectHowToPayDeferred_1 = require("../../deferredActions/SelectHowToPayDeferred");
const Size_1 = require("../render/Size");
const Resources_1 = require("../../Resources");
class Merger extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.MERGER,
            metadata: {
                cardNumber: 'X41',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.corporation().asterix().nbsp().megacredits(-42, Size_1.Size.SMALL);
                    b.br.br;
                }),
                description: 'Draw 4 corporation cards. Play one of them and discard the other 3. Then pay 42 M€.',
            },
        });
        this.mergerCost = 42;
    }
    play(player) {
        const game = player.game;
        const dealtCorps = Merger.dealCorporationCards(player, game.dealer);
        if (dealtCorps.length === 0) {
            game.log('There are no corporation cards left in the deck');
            player.addResource(Resources_1.Resources.MEGACREDITS, 15, { log: true });
            return undefined;
        }
        const availableCorps = dealtCorps.filter((corp) => {
            const balance = this.mergerCost - corp.startingMegaCredits;
            return player.canAfford(balance);
        });
        if (availableCorps.length === 0) {
            game.log('None of the four drawn corporation cards are affordable.');
            player.addResource(Resources_1.Resources.MEGACREDITS, 15, { log: true });
            return undefined;
        }
        game.defer(new DeferredAction_1.DeferredAction(player, () => {
            return new SelectCard_1.SelectCard('Choose corporation card to play', 'Play', availableCorps, (foundCards) => {
                Merger.playSecondCorporationCard(player, foundCards[0]);
                game.defer(new DeferredAction_1.DeferredAction(player, () => {
                    for (const corp of foundCards) {
                        if (corp.name !== foundCards[0].name) {
                            game.dealer.discardCorporation(corp);
                        }
                    }
                    return undefined;
                }));
                return undefined;
            });
        }));
        game.defer(new SelectHowToPayDeferred_1.SelectHowToPayDeferred(player, this.mergerCost, { title: 'Select how to pay for Merger prelude' }));
        return undefined;
    }
    static dealCorporationCards(player, dealer) {
        const cards = [];
        const corpsInPlay = player.game.getPlayers().map((p) => p.corporationCards).reduce((a, b) => a.concat(b)).map((c) => c.name);
        const discardedCorpNames = dealer.discardedCorporations.map((c) => c.name);
        let candidateCards = dealer.corporationCards.filter((card) => !corpsInPlay.includes(card.name));
        candidateCards = candidateCards.filter((card) => !discardedCorpNames.includes(card.name));
        candidateCards = Dealer_1.Dealer.shuffle(candidateCards);
        while (cards.length < 4) {
            const card = candidateCards.pop();
            if (card === undefined)
                break;
            dealer.corporationCards.splice(dealer.corporationCards.indexOf(card), 1);
            cards.push(card);
        }
        LogHelper_1.LogHelper.logDrawnCards(player, cards, true, DrawCards_1.LogType.DREW);
        return cards;
    }
    static playSecondCorporationCard(player, corporationCard) {
        player.corporationCards.push(corporationCard);
        player.megaCredits += corporationCard.startingMegaCredits;
        Merger.setCardCostIfNeeded(player, corporationCard);
        corporationCard.play(player);
        if (corporationCard.initialAction !== undefined)
            player.pendingInitialActions.push(corporationCard);
        player.game.log('${0} played ${1}', (b) => b.player(player).card(corporationCard));
        Merger.triggerOtherCorpEffects(player, corporationCard);
        Merger.activateColonies(player.game, corporationCard);
        ;
    }
    static setCardCostIfNeeded(player, corporationCard) {
        const corpNames = player.corporationCards.map((corp) => corp.name);
        if (corporationCard.cardCost !== undefined) {
            if (corpNames.includes(CardName_1.CardName.TERRALABS_RESEARCH) && corpNames.includes(CardName_1.CardName.POLYPHEMOS)) {
                player.cardCost = constants_1.CARD_COST;
            }
            else {
                player.cardCost = corporationCard.cardCost;
            }
        }
    }
    static triggerOtherCorpEffects(player, corporationCard) {
        for (const somePlayer of player.game.getPlayers()) {
            somePlayer.corporationCards.forEach((corp) => {
                if (corp.onCorpCardPlayed !== undefined && corp.name !== corporationCard.name) {
                    player.game.defer(new DeferredAction_1.DeferredAction(player, () => {
                        if (corp.onCorpCardPlayed !== undefined) {
                            return corp.onCorpCardPlayed(player, corporationCard) || undefined;
                        }
                        return undefined;
                    }));
                }
            });
        }
    }
    static activateColonies(game, corporationCard) {
        if (game.gameOptions.coloniesExtension && corporationCard.resourceType !== undefined) {
            game.colonies.forEach((colony) => {
                if (colony.resourceType !== undefined && colony.resourceType === corporationCard.resourceType) {
                    colony.isActive = true;
                }
            });
            game.activateVenusColony(corporationCard);
        }
    }
}
exports.Merger = Merger;
//# sourceMappingURL=Merger.js.map